import { createContext } from 'react';
const defaultEllipsisContext = {
  displayTruncatedText: '',
  setDisplayTruncatedText: () => {}
};
export const EllipsisContext = /*#__PURE__*/createContext(defaultEllipsisContext);
//# sourceMappingURL=EllipsisContext.js.map